'use client';

import { InfoBanner, Row, Typography } from '@viewup/ui';

type Props = {
  onClick: () => void;
};

export const DefaultViewingBanner = ({ onClick }: Props) => (
  <InfoBanner onClick={onClick} slots={{ root: { css: { cursor: 'pointer' }, mt: 8 } }}>
    <Row alignItems='center' gap={4}>
      <Typography color='text.info' fontType='body2.bold'>
        EVENT!
      </Typography>
      <Typography fontType='body2.regular'>
        매일 출석 도장 쾅! 포인트가 차곡차곡 쌓여요 🎁
      </Typography>
    </Row>
  </InfoBanner>
);
